// 45be085d06f2b331b038fb65c016444f3a7ecebd|kind=api-js|className=CompanyTypeApi|type=angular|apiName=entity|apiEnumKey=Entity|operationHash=ca0b64f006dd7caae48e26830bab79c957aaebc4

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';

import { parseOkResponseWrappingCompanyTypeListFromJSON } from '../../../parsers/OkResponseWrappingCompanyTypeList';

export class CompanyTypeApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @tags CompanyTypeApi
   * @name CompanyTypeApiGetCompanyTypes
   * @summary Get all company types
   * @request GET:/company-types
   */
  getCompanyTypes(
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/company-types`,
        method: 'GET',
        api: Api.Entity,
      },
      {
        ...requestOptions,
        parser: parseOkResponseWrappingCompanyTypeListFromJSON,
      },
    );
  }

  static ɵfac = function CompanyTypeApi_Factory(t) { return new (t || CompanyTypeApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: CompanyTypeApi, factory: CompanyTypeApi.ɵfac, providedIn: 'root' });
}
